import { render, staticRenderFns } from "./PropImg.vue?vue&type=template&id=f98216d4&scoped=true&"
import script from "./PropImg.vue?vue&type=script&lang=js&"
export * from "./PropImg.vue?vue&type=script&lang=js&"
import style0 from "./PropImg.vue?vue&type=style&index=0&id=f98216d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98216d4",
  null
  
)

export default component.exports